const appSettings = {
  appName: 'CMSX',
  appVer: 'seed 27.09.21',

  company: null,
  companies: {
    'PRIME': {name: 'PRIME'},
    'NBSK': {name: 'НЕБОСКРЕБ'},
    'localhost': {name: 'localhost'}
  },
  // welcomePage: '/admin',
  // userProfilePage: './admin/profile',

  companiesConfigs: {
    'NBSK': {
      appModules: {
      }
    },
    'PRIME': {
      appModules: {
      }
    },
    'localhost': {
      appModules: {
      }
    }
  },

  server: {
    hostName: null,
    host: null,
    hosts: {
      'NBSK': 'https://nbsk.cmsx.rokkets.ru/api/',
      'PRIME': 'https://prime.cmsx.rokkets.ru/api/',
      'localhost': 'http://localhost:1502/api/'
    },

    cmsReinit: 'system/cmsReinit',
    modelsNotifierSubscription: 'system/subscribeToRoomOrModel',

    settingsResource: 'settings/findBugfixed',
    mainMenuPermissionsByUserGroupsCriteria: '?where={"uniqueName":["mainMenuPermissionsByUserGroups"]}',

    // {'where': '{"ID":[17,29]}'

    userResource: 'cmsUserAdminPanel',
    userLogin: 'cmsUserAdminPanel/login',
    // userGetUsersListToLogin: 'cmsUserAdminPanel/getUsersListToLogin',
    // usersGetSalersAdminsCriteria: {'where': '{"ID":[17,29]}', 'sort': 'Name asc'},
    userGetActiveUser: 'cmsUserAdminPanel/getActiveUser',
    userLogout: 'cmsUserAdminPanel/logout',
    userActiveChangePassword: 'cmsUserAdminPanel/activeUserChangePassword',
    userChangeName: 'cmsUserAdminPanel/userChangeName',

    userGroupResource: 'cmsUserAdminPanelGroup',

    cmsConfigResource: 'cmsConfig',
    cmsPageResource: 'cmsPage',
    cmsContentResource: 'cmsContent',
    cmsBlockResource: 'cmsBlock',
    cmsMenuResource: 'cmsMenu',
    cmsIShopProductResource: 'cmsIShopProduct',
    cmsMenuItemResource: 'cmsMenuItem',
    cmsUserSiteResource: 'cmsUserSite',

    cmsMediaFilesCriteria: '/findBugfixed?where={"container":["cmsMedia"]}',
    fileEntityResource: 'fileEntity',
    fileEntityGetFile: 'fileEntity/getFile/',
    fileEntityGetFileUpToDate: 'fileEntity/getFile?id='

    // apiVer: 'v1.0/'
    // ajaxRequestTimeout: 5000 //5 sec
  }
}

export default {
  state: {
    appSettings: appSettings
  },
  getters: {
    appSettings: state => state.appSettings
  },
  mutations: {
    serverHostSet (state, newServerHostName) {
      state.appSettings.server.hostName = newServerHostName
      state.appSettings.server.host = state.appSettings.server.hosts[newServerHostName]
      state.appSettings.company = state.appSettings.companies[newServerHostName]
      if (state.appSettings.company != null) state.appSettings.company.config = state.appSettings.companiesConfigs[newServerHostName]
    }
  }
}



// WEBPACK FOOTER //
// ./src/settings.js